module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.6422ede.woff2";